/**
 * Lightbox
 */
(function($){
    var $body = $(document.body);

    /**
     * Lightbox
     **/
    $(".lightbox").each(function(){
        var $this = $(this);

        var title = $this.data('title');
        if (!title) {
            if (!title && $this.attr('title')) {
                title = $this.attr('title');
            }
            if (!title && $this.find('img').attr('alt')) {
                title = $this.find('img').attr('alt');
            }

            $this.data('title', title);
        }

        var html = $this.parents('section').find('.hidden-content').html();

        $this.data('footer', html);

        $this.on('click', function(){
            $(this).ekkoLightbox({
                showArrows: true,
                type: 'image',
                alwaysShowClose: true,
                width: '70vw',
                height: '70vh'
            });
            return false;
        });
    });
})(jQuery);
